import { ReactNode } from 'react';
import BootstrapNav from 'react-bootstrap/Nav';
import { SelectCallback } from 'react-bootstrap/helpers';

import ELEMENT from 'common/element';

import './Tab.scss';

/**
 * A component that renders a navigational tab with a link. It uses a children prop so that you can
 * even pass in icons.
 */

type TabProps = {
  eventKey:  string;
  children:  ReactNode;
  onSelect?: SelectCallback;
  testId?:   ELEMENT;
};

function Tab({
  children,
  eventKey,
  onSelect,
  testId,
}: TabProps): JSX.Element {

  return (
    <BootstrapNav.Item className="Tab">
      <BootstrapNav.Link
        className="Tab__Link"
        eventKey={eventKey}
        onSelect={onSelect}
        data-test-id={testId}
      >
        {children}
      </BootstrapNav.Link>
    </BootstrapNav.Item>
  );
}

export default Tab;
